<template>
  <div class="page-wrapper">
    <ion-header class="rp-desktop">
      <ion-toolbar class="header-toolbar">
        <ion-title>New Reservation/Confirm</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="res-wrapper">
        <div class="res-icon">
          <img class="icon-img" src="/assets/images/confirmationsuccess/907830.png" />
        </div>
        <p class="ion-no-margin fontRobotoMedium res-msg">Reservation Confirmed</p>
        <!-- p class="ion-no-margin fontRobotoMedium res-id">Your reservation # is {{reservationInfo ? reservationInfo.refNo : ''}}</p -->
        <!-- p class="ion-no-margin fontRobotoMedium res-id">Bay Name is {{reservationInfo ? reservationInfo.bayName : ''}} and Connector is {{reservationInfo ? reservationInfo.portName : ''}}</p -->
        <p class="ion-no-margin fontRobotoMedium res-msg">Details:</p>
        <ion-grid fixed>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="12" class="col-padding">
              <ion-grid>
                <ion-row>
                  <ion-col class="confirmation-info">Reservation # </ion-col>
                  <ion-col class="confirmation-info-data">{{reservationInfo ? reservationInfo.refNo : ''}}</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="confirmation-info">Bay Name</ion-col>
                  <ion-col class="confirmation-info-data">{{reservationInfo ? reservationInfo.bayName : ''}}</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="confirmation-info">Connector</ion-col>
                  <ion-col class="confirmation-info-data">{{reservationInfo ? reservationInfo.portName : ''}}</ion-col>
                </ion-row>
              </ion-grid>      
            </ion-col>
          </ion-row>
        </ion-grid>  
      </div>
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol } from "@ionic/vue";

import { WalletService } from "@/service/wallet/wallet.service";
import { EVCStationReservationService } from "@/service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";

export default defineComponent ({
  name: 'resConfirm',
  components: {
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent, 
    IonGrid, 
    IonRow, 
    IonCol
  },
  data() {
    return {
      refNumber: "",
      reservationInfo: null
    }
  },
  mounted() {
    // this.refNumber = localStorage.getItem("refNumber");
    this.reservationInfo = JSON.parse(localStorage.getItem("reservationInfo"));
    localStorage.removeItem("slotDetails");
    localStorage.removeItem("previousPath");
    localStorage.removeItem("vehiclePath");
    localStorage.removeItem("editReservationDetails");
    localStorage.removeItem("editReservationPage");
    localStorage.removeItem("teleUrl");
    localStorage.removeItem("selectedMarker");
    localStorage.removeItem("opensAt");
    localStorage.removeItem("closesAt");
    localStorage.removeItem("selectedChargerValue");
    localStorage.removeItem("amountDetails");
    this.resRedirection();
  },
  methods: {
    resRedirection() {
      setTimeout(() => {
        this.$router.push("/customer/reservation");
      }, 5000);
    },
  },
})
</script>

<style scoped>
ion-content {
  --background: #21b24b;
  position: absolute;
  --padding-bottom: 108px;
  --padding-top: 54px;
}
.res-id-num {
  color: #072a8a;
  font-weight: 700;
}
ion-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
}

.textAlignRight {
  text-align: right;
}

/* Title */
@media (max-width: 768px) {
  .title-add-wrapper .add-wrapper .loc-img {
    margin-right: 13px !important;
  }

  .header-toolbar,
  .mobile-header-toolbar {
    --background: #21b24b;
  }

  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }

  .mobile-header-toolbar ion-title {
    color: #fff;
  }

  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }

  .title-add-wrapper {
    padding-left: 18px !important;
    padding-right: 24px !important;
  }

  .paddingRight {
    padding-right: 0px !important;
  }
}

@media (min-width: 768px) {
  .title-wrapper .price-tag {
    float: right;
  }

  .title-wrapper .price-tag {
    display: inline-block;
    margin-right: 20px;
    padding-top: 5px;
    padding-bottom: 7px;
  }

  .title-wrapper .price-tag p:first-child,
  .title-wrapper .price-tag p:last-child,
  .title-wrapper ion-title {
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
  }

  .title-wrapper ion-title {
    padding-top: 10px;
  }

  .title-wrapper .price-tag p:last-child {
    font-family: "Roboto Medium";
  }
}

/* Title */

.fontRobotoBold {
  font-family: "Roboto Bold";
}

.fontRobotoMedium {
  font-family: "Roboto Medium";
}

.fontRobotoLight {
  font-family: "Roboto light";
}

.fontRoboto {
  font-family: "Roboto";
}

.res-icon {
  width: 60px;
  height: 60px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  position: relative;
  margin: 0 auto;
  border-radius: 50%;
}

.res-icon .icon-img {
  width: 26px;
  height: 18px;
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.res-msg {
  color: #ffffff;
  opacity: 1;
  font-size: 18px;
  margin-top: 18px;
}

.res-id {
  color: #ffffff;
  opacity: 1;
  font-size: 13px;
  margin-top: 16px;
}

.res-wrapper {
  text-align: center;
  position: absolute;
  width: 100%;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}

.confirmation-info {
  margin: 0px auto;
  width: 100%;
  height: 30px;
  /* background-color: #041648; */
  background-color: #21b24b;
  text-align: center;
  padding: 5px 0;
  position: relative;
  white-space: nowrap !important;
  z-index: 10;
  color: white;
  border: 1px solid #041648;
  font-weight: bold;
}
/* This confirmation-info:after class is not replect in latest iOS, on 03-03-2025 */
/* .confirmation-info:after {
  background-color: #21b24b;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: -1;
} */
.confirmation-info-data {
  margin: 0px auto;
  width: 100%;
  height: 30px;
  /* background-color: #041648; */
  background-color: #21b24b;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap !important;
  padding: 5px 0;
  position: relative;
  z-index: 10;
  color: white;
  border: 1px solid #041648;
  font-weight: bold;
}
  /* This confirmation-info-data:after class is not replect in latest iOS, on 03-03-2025 */
/* .confirmation-info-data:after {
  background-color: white;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: -1;
} */
</style>